import { createStore as reduxCreateStore } from "redux"
import { SpiceDetails, DhoopDetails, Misc } from "../Constants/productListConstant"
const reducer = (state, action) => {
	console.info("--------------------")
	console.info("\x1b[36m", "prev state -> ", state)
	console.info("\x1b[36m", "action", action)
	let { products: { meta } } = state
	if (meta.isFetching) {
		// console.log("ProductList", ProductList)
		let list = [...SpiceDetails, ...DhoopDetails, ...Misc]
		let listItemById = {}
		let uIdListItemById = {}
		let wholeMasalas = []
		let blendedMasalas = []
		let specialities = []
		let pujaMaterials = []
		list.map((item) => {
			if (uIdListItemById[item.u_id] === undefined || uIdListItemById[item.u_id] === null) {
				uIdListItemById[item.u_id] = []
			}
			// if (listItemById[item.id] === undefined || listItemById[item.id] === null) {
			// 	listItemById[item.id] = {}
			// }
			if (item.ingredients === "1" && item.type_id === "Spices") {
				wholeMasalas.push(item)
			} else if (item.type_id === "Spices") {
				blendedMasalas.push(item)
			}
			if (item.type_id === "Misc") {
				specialities.push(item)
			} else if (item.type_id === "Dhoop") {
				pujaMaterials.push(item)
			}
			uIdListItemById[item.u_id].push(item)
			listItemById = {
				...listItemById,
				[item.id]: item
			}
			uIdListItemById[item.u_id].sort((a, b) => {
				return a.mrp - b.mrp
			})
			// console.log("uIdListItemById", uIdListItemById)
		})
		state = Object.assign({}, state, {
			products:  {
				...state.products,
				list,
				listItemById,
				uIdListItemById,
				wholeMasalas,
				blendedMasalas,
				specialities,
				pujaMaterials,
				meta: {
					isFetching: false
				}
			}
		})
	}

	if (action.type === `INCREMENT`) {
		state = Object.assign({}, state, {
			count: state.count + action.index,
		})
		// return state
	}
	if (action.type === `FETCHED_USER_DATA`) {
		state = Object.assign({}, state, {
			user: action.user,
		})
		// return state
	}
	if (action.type === `FETCHED_PRODUCT_LIST`) {
		const { list } = action
		let listItemById = {}
		let uIdListItemById = {}
		let wholeMasalas = []
		let blendedMasalas = []
		let specialities = []
		let pujaMaterials = []
		list.map((item) => {
			uIdListItemById = {
				...uIdListItemById,
				[item.u_id]: item
			}
			if (listItemById[item.id] === undefined || listItemById[item.id] === null) {
				listItemById[item.id] = []
			}
			if (item.ingredients === "1" && item.type_id === "Spices") {
				wholeMasalas.push(item)
			} else if (item.type_id === "Spices") {
				blendedMasalas.push(item)
			}
			if (item.type_id === "Misc") {
				specialities.push(item)
			} else if (item.type_id === "Dhoop") {
				pujaMaterials.push(item)
			}
			listItemById[item.id].push(item)
		})
		state = Object.assign({}, state, {
			products:  {
				...state.products,
				list,
				listItemById,
				uIdListItemById,
				wholeMasalas,
				blendedMasalas,
				specialities,
				pujaMaterials,
				meta: {
					isFetching: false
				}
			}
		})
		// return state
	}
	if (action.type === `SET_TO_CART`) {
		const { addToCartList } = action
		state = Object.assign({}, state, {
			addToCartList: {
				...addToCartList,
				isAddToCartChange: !state.addToCartList.isAddToCartChange
			}
		})
	}
	if (action.type === `ADD_TO_CART`) {
		const { list } = action
		state = Object.assign({}, state, {
			products:  {
				...state.products,
				cart: list,
				cartChange: !state.products.isCartChange
			}
		})
	}
	if (action.type === `SET_MACHINE_ADDRESS`) {
		const { ipData } = action
		state = Object.assign({}, state, {
			ipData:  ipData
		})
	}
	console.info("\x1b[36m", "next state -> ", state)
	console.info("--------------------")
	// state = { ...stateObj }
	return state
}

const initialState = {
	count: 0,
	user: {},
	addToCartList: { products: {}, totalNumber: 0, isAddToCartChange: false },
	products: { list: [], meta: { isFetching: true }, cart: {}, cartChange: false },
	ipData: {}
}

const createStore = () => reduxCreateStore(reducer, initialState)
export default createStore



// WEBPACK FOOTER //
// ./src/state/createStore.js